import { styled } from '@mui/material/styles';
import { Typography, Box } from '@mui/material';

interface PolicyInformationProps {
	vehicleMake: string;
	vehicleModel: string;
	registrationNumber: string;
	policyNumber: string;
}

const SectionHeading = styled(Typography)({
	fontSize: '16px',
	lineHeight: '24px',
	fontWeight: 700,
});

const PolicyInformation = ({ vehicleMake, vehicleModel, registrationNumber, policyNumber }: PolicyInformationProps) => {
	return (
		<Box border='1px solid #EDEDED' borderRadius='8px' padding='16px'>
			<Box display='flex' flexDirection='column' marginBottom='16px' width='100%'>
				<SectionHeading>Vehicle</SectionHeading>
				<Typography>
					{vehicleMake}, {vehicleModel}
				</Typography>
			</Box>
			<Box display='flex' flexDirection='row' gap='24px' width='100%'>
				<Box width='50%'>
					<SectionHeading>Registration</SectionHeading>
					<Typography>{registrationNumber}</Typography>
				</Box>
				<Box width='50%'>
					<SectionHeading>Reference</SectionHeading>
					<Typography>{policyNumber}</Typography>
				</Box>
			</Box>
		</Box>
	);
};

export default PolicyInformation;
